/* eslint-disable react/prop-types */

// preact stuff
import { Fragment, h } from 'preact';

// my components
import AddonAdder from './AddonAdder';
import AddonList from './AddonList';
import AddSingleAddon from './AddSingleAddon';

// this is A HOC / manager component for the addon system
const AddonManager = ({ dispatch, milkOption, optionState }) => {
  return (
    <Fragment>
      <div className="addonContainer">
        <h4 style={{ margin: '1.25em 0px' }}>Additional Options</h4>
        {/* Select dropdown for addons */}
        <AddonAdder
          possibleOptions={optionState.unselected}
          dispatch={dispatch}
        />
        {/* List of all addons currently */}
        <AddonList options={optionState.selected} dispatch={dispatch} />
        {!optionState.selected.includes(milkOption) && (
          <AddSingleAddon
            btnTitle="Add Milk Alternative"
            dispatch={dispatch}
            option={milkOption}
          />
        )}
      </div>
    </Fragment>
  );
};

export default AddonManager;
